interface Review {
  id: string;
  quote: string;
  name: string;
  city: string;
  rating: 1 | 2 | 3 | 4 | 5;
  source: 'google' | 'direct';
}

// TODO: Mit echten Kundenstimmen ersetzen (Google-Profil oder direkt vom Kunden).
export const reviews: Review[] = [
  {
    id: 'r1',
    quote:
      'Schnell, professionell und unglaublich schonend für unsere alte Eiche. Die Seilklettertechnik hat uns beeindruckt.',
    name: 'Familie Petersen',
    city: 'Ahrensburg',
    rating: 5,
    source: 'direct',
  },
  {
    id: 'r2',
    quote:
      'Nach dem Sturm kam Herr Sträßer am selben Tag. Faire Preise, klare Kommunikation, sauber hinterlassen.',
    name: 'M. Hansen',
    city: 'Hamburg-Bergedorf',
    rating: 5,
    source: 'direct',
  },
  {
    id: 'r3',
    quote:
      'Beratung war ehrlich – statt Fällung kam ein gezielter Rückschnitt. Der Baum lebt, wir sparen Geld. Top.',
    name: 'C. Wiegand',
    city: 'Reinbek',
    rating: 5,
    source: 'direct',
  },
  {
    id: 'r4',
    quote:
      'Baumhaus für die Kinder ist ein Traum geworden. Gut gemacht – und der Baum lebt prächtig weiter.',
    name: 'Familie Brandt',
    city: 'Bargteheide',
    rating: 5,
    source: 'direct',
  },
];
